/*window.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.subify-powered-text').forEach(function(tw_subify_powered_text) {
    tw_subify_powered_text.style.setProperty('display', 'none', 'important');
  });
});*/

var tw_product_chosen_options = [];

function tw_product_variant_picker_update_option_prices() {
  tw_get_product_variants_json();
  var i_tw_product_variant_picker_fieldset, tw_product_variant_picker_fieldset;
  var tw_product_variant_picker_fieldset_chosen_option;
  var tw_product_variant_picker_fieldsets = tw_product_variant_picker.querySelectorAll('fieldset');
  for(i_tw_product_variant_picker_fieldset = 0; i_tw_product_variant_picker_fieldset < tw_product_variant_picker_fieldsets.length; i_tw_product_variant_picker_fieldset++) {
    tw_product_variant_picker_fieldset = tw_product_variant_picker_fieldsets.item(i_tw_product_variant_picker_fieldset);
    //console.log('tw_product_variant_picker_fieldset', tw_product_variant_picker_fieldset);
    tw_product_variant_picker_fieldset_chosen_option = tw_product_variant_picker_fieldset.querySelector('input[type="radio"]:checked');
    if(tw_product_variant_picker_fieldset_chosen_option) {
      tw_product_chosen_options['option' + (i_tw_product_variant_picker_fieldset + 1)] = tw_product_variant_picker_fieldset_chosen_option.value;
    }
  }
  //console.log('tw_product_chosen_options', tw_product_chosen_options);

  var i_tw_product_variant_picker_fieldset_option, tw_product_variant_picker_fieldset_option;
  var i_tw_product_variants_json_item, tw_product_variants_json_item;
  var tw_product_variant_picker_fieldset_options_values_match;
  var i_tw_product_chosen_option, tw_product_chosen_option;
  var tw_product_variant_picker_fieldset_option_amount_of_cups_element;
  var tw_product_variant_picker_fieldset_option_price_element;
  var tw_product_variant_picker_fieldset_option_price_per_cup_element;
  var tw_product_variant_picker_fieldset_option_discount_element;
  var tw_product_variant_picker_fieldset_option_compare_at_price;
  for(i_tw_product_variant_picker_fieldset = 0; i_tw_product_variant_picker_fieldset < tw_product_variant_picker_fieldsets.length; i_tw_product_variant_picker_fieldset++) {
    tw_product_variant_picker_fieldset = tw_product_variant_picker_fieldsets.item(i_tw_product_variant_picker_fieldset);
    tw_product_variant_picker_fieldset_options = tw_product_variant_picker_fieldset.querySelectorAll('input[type="radio"]');
    for(i_tw_product_variant_picker_fieldset_option = 0; i_tw_product_variant_picker_fieldset_option < tw_product_variant_picker_fieldset_options.length; i_tw_product_variant_picker_fieldset_option++) {
      tw_product_variant_picker_fieldset_option = tw_product_variant_picker_fieldset_options.item(i_tw_product_variant_picker_fieldset_option);
      for(i_tw_product_variants_json_item in tw_product_variants_json) {
        tw_product_variants_json_item = tw_product_variants_json[i_tw_product_variants_json_item];
        if ( // First, check if the value of the option value that needs a price is the same option value as the one in the JSON
          tw_product_variant_picker_fieldset_option.value
          ===
          tw_product_variants_json_item['option' + (i_tw_product_variant_picker_fieldset + 1)]
        ) {
          // Second, check if the other options match
          tw_product_variant_picker_fieldset_options_values_match = true;
          for(i_tw_product_chosen_option in tw_product_chosen_options) {
            if(i_tw_product_chosen_option !== 'option' + (i_tw_product_variant_picker_fieldset + 1)) {
              tw_product_chosen_option = tw_product_chosen_options[i_tw_product_chosen_option];
              if (
                tw_product_chosen_option
                ===
                tw_product_variants_json_item[i_tw_product_chosen_option]
              ) {
                // Do nothing, this one matches
              } else {
                tw_product_variant_picker_fieldset_options_values_match = false;
              }
            } else {
              // Do nothing, this one is already checked against the option value that needs a price
            }
          }
          if(tw_product_variant_picker_fieldset_options_values_match) {
            tw_product_variant_picker_fieldset_option.setAttribute('data-price', tw_product_variants_json_item.price / 100);

            if(tw_product_variants_json_item.compare_at_price && tw_product_variants_json_item.compare_at_price > tw_product_variants_json_item.price) {
              tw_product_variant_picker_fieldset_option_compare_at_price = tw_product_variants_json_item.compare_at_price;
              tw_product_variant_picker_fieldset_option.setAttribute('data-price-compare', tw_product_variant_picker_fieldset_option_compare_at_price);
            } else {
              tw_product_variant_picker_fieldset_option_compare_at_price = false;
            }
            tw_product_variant_picker_fieldset_option_price_element = tw_product_variant_picker_fieldset_option.parentElement.querySelector('.tw-product-option-price');
            tw_product_variant_picker_fieldset_option_discount_element = tw_product_variant_picker_fieldset_option.parentElement.querySelector('.tw-product-option-discount');
            if(tw_product_variant_picker_fieldset_option_price_element) {
              if(tw_product_variant_picker_fieldset_option_compare_at_price) {
                tw_product_variant_picker_fieldset_option_price_element.innerHTML = (
                  '<ins>' + tw_format_price(tw_product_variants_json_item.price / 100) + '</ins>'
                  + ' '
                  + '<del>' + tw_format_price(tw_product_variant_picker_fieldset_option_compare_at_price / 100) + '</del>'
                );
                if(tw_product_variant_picker_fieldset_option_discount_element) {
                  tw_product_variant_picker_fieldset_option_discount_element.textContent = Math.round((tw_product_variants_json_item.price - tw_product_variant_picker_fieldset_option_compare_at_price) / tw_product_variants_json_item.price * 100) + '%';
                }
              } else {
                tw_product_variant_picker_fieldset_option_price_element.innerHTML = tw_format_price(tw_product_variants_json_item.price / 100);
                if(tw_product_variant_picker_fieldset_option_discount_element) {
                  tw_product_variant_picker_fieldset_option_discount_element.textContent = '';
                }
              }
            }
            tw_product_variant_picker_fieldset_option_amount_of_cups_element = tw_product_variant_picker_fieldset_option.parentElement.querySelector('.tw-product-option-amount-of-cups');
            tw_product_variant_picker_fieldset_option_price_per_cup_element = tw_product_variant_picker_fieldset_option.parentElement.querySelector('.tw-product-option-price-per-cup');
            if (
              tw_product_variant_picker_fieldset_option_amount_of_cups_element
              &&
              tw_product_variant_picker_fieldset_option_price_per_cup_element
            ) {
              tw_product_variant_picker_fieldset_option_price_per_cup_element.textContent = (
                tw_format_price (
                  (tw_product_variants_json_item.price / 100)
                  /
                  parseInt(tw_product_variant_picker_fieldset_option_amount_of_cups_element.getAttribute('data-cups'))
                )
                +
                '/st.'
              );
            }
          } else {
            // Do nothing, this is not the one
          }
        } else {
          // Do nothing, this is not the one
        }
      }
    }
  }
}

var tw_product_variant_picker;
var tw_product_variants_json_script, tw_product_variants_json;
var tw_product_variant_id_hidden_input;
function tw_get_product_variants_json() {
  tw_product_variant_picker = document.querySelector('.variant-picker');
  if(tw_product_variant_picker) {
    tw_product_variants_json_script = tw_product_variant_picker.querySelector('script[type="application/json"]');
    if(tw_product_variants_json_script) {
      tw_product_variants_json = JSON.parse(tw_product_variants_json_script.textContent);
      //console.log('tw_product_variants_json', tw_product_variants_json);
    }
  }
}
window.addEventListener('DOMContentLoaded', function() {
  tw_get_product_variants_json();
  tw_product_variant_picker_update_option_prices();
  tw_product_variant_id_hidden_input = document.querySelector('#main-product-form input[name="id"]');
  tw_product_variant_id_hidden_input.addEventListener('change', tw_product_variant_picker_update_option_prices);
});